/**
 * DreamPay Private API [DEPRECATED]
 * ⚠️ **DEPRECATED** - This API version is deprecated and will be removed on 2026-05-31. Please migrate to V2.  Private API v1 - Legacy endpoints for DreamPay payment processing platform.
 *
 * The version of the OpenAPI document: v1
 * Contact: suporte@dreampay.com.br
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface Pix {
  id?: string;
  reference?: string;
  tid?: string;
  creationDateTime?: string;
  amount?: number;
  qrcodeResponseDateTimeExpiration?: string;
  qrcodeResponseImage?: string;
  qrcodeResponseData?: string;
  returnCode?: string;
  returnMessage?: string;
  transactionId?: number;
  status?: string;
  statusChangedDateTime?: string | null;
  refunded?: boolean;
  refundDateTime?: string | null;
  refundAmount?: number | null;
  refundId?: string | null;
  refundStatus?: string | null;
  establishmentId?: number;
  purchaseAmount?: number;
  purchaseCurrency?: string;
  posId?: string | null;
  paymentLinkId?: string | null;
  cpf?: string | null;
  amountBrl?: number | null;
  exchangeRate?: number;
  iof?: number;
  spread?: number;
  pixProcessmentFee?: number;
  pixProcessmentCostBrl?: number | null;
  estimatedRemittanceCostBrl?: number | null;
  estimatedMarginBrl?: number | null;
  estimatedMarginPercentage?: number | null;
  customerName?: string | null;
  customerEmail?: string | null;
  customerPhoneNumber?: string | null;
  customerAddress?: string | null;
  customerCity?: string | null;
  customerZipCode?: string | null;
  customerCountryId?: number;
  establishmentName?: string | null;
  countryName?: string | null;
}
